import { cn } from '@/lib/utils';
import type { ParamStatus } from './types';

const STYLES: Record<ParamStatus, string> = {
  ACTIVE:           'bg-emerald-500/10 text-emerald-700',
  PENDING_APPROVAL: 'bg-amber-500/10  text-amber-700',
  DRAFT:            'bg-secondary     text-secondary-foreground',
  ARCHIVED:         'bg-muted         text-muted-foreground',
};

export function StatusBadge({ status }: { status: ParamStatus }) {
  return (
    <span className={cn('rounded px-1.5 py-0.5 text-[11px] font-medium', STYLES[status])}>
      {status.replace(/_/g, ' ')}
    </span>
  );
}
